import { styled } from 'styles/stitches.config'
import { rem } from 'polished'
import { Grid as GridChakra } from '@chakra-ui/react'

import ButtonComponent from 'components/Button'

export const Comments = styled('div', {
  '& h4': {
    fontSize: '32px !important',
    marginBottom: 24,
  },
})

export const Comment = styled('div', {
  width: '100%',

  '&:not(:last-of-type)': {
    marginBottom: 32,
  },

  '& h4': {
    fontSize: '32px !important',
    marginBottom: 24,
  },
})

export const Box = styled('div', {
  position: 'relative',

  display: 'flex',
})

export const Right = styled('div', {
  marginLeft: 24,
  paddingBottom: 16,
  flex: 1,

  width: 'calc(100% - 80px)',

  borderBottom: 'solid 1px',
  borderBottomColor: '$grey300',
})

export const Name = styled('label', {
  marginBottom: 6,
  display: 'block',

  fontSize: rem(16),
  fontFamily: '$domine',
  fontWeight: 'bold',
  color: '$grey900',
})

export const Menssage = styled('p', {
  marginBottom: 16,

  width: '100%',

  fontFamily: '$raleway',
  fontSize: rem(13),
  color: '$grey600',
})

export const Hour = styled('time', {
  marginBottom: 10,
  display: 'flex',
  alignItems: 'center',

  fontFamily: '$raleway',
  fontSize: rem(11),
  color: '$grey600',

  '@sm': {
    position: 'absolute',
    right: 0,
    top: 0,

    marginBottom: 0,
  },

  '& svg': {
    marginRight: 8,
  },
})

export const Actions = styled('div', {
  display: 'flex',
})

export const ActionsButtons = styled('button', {
  all: 'unset',

  display: 'flex',
  alignItems: 'center',

  fontFamily: '$raleway',
  fontSize: rem(11),
  color: '$grey600',
  cursor: 'pointer',

  '& svg': {
    marginRight: 8,
  },

  '&:hover': {
    opacity: 0.8,
  },

  '&:not(:last-of-type)': {
    marginRight: 16,
  },
})

export const Form = styled('form', {
  marginTop: 56,
})

export const Grid = styled(GridChakra, {
  gridTemplateColumns: 'repeat(1, 1fr)',

  '@md': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
})

export const Button = styled(ButtonComponent, {
  position: 'relative',

  marginTop: 56,

  '& svg': {
    marginLeft: 5,
    marginTop: '-2px',
  },
})

export const CommentBox = styled('div', {
  padding: '25px',
  border: '1px solid #eee',
  marginBottom: '24px',
  borderRadius: '15px',
})

export const SubComments = styled('div', {
  marginLeft: 40,
  padding: 20,
  transform: 'scale(0.9)',
})
